import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

type InitialLayoutState = {
    isNavbar: boolean
    isWidgetsOpen: boolean
    isContentLoading: boolean
}

const initialState: InitialLayoutState = {
    isNavbar: false,
    isWidgetsOpen: true,
    isContentLoading: false
}

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setNavbar: (state, action: PayloadAction<boolean>) => {
            state.isNavbar = action.payload
        },
        setWidgetExpand: (state, action: PayloadAction<boolean>) => {
            state.isWidgetsOpen = action.payload
        },
        setContentLoading: (state, action: PayloadAction<boolean>) => {
            state.isContentLoading = action.payload
        },
    },
})

export const { setNavbar, setWidgetExpand, setContentLoading } = layoutSlice.actions

export default layoutSlice.reducer

